/* Actions */
export const GET_REQUEST = "GET_REQUEST";
export const POST_REQUEST = "POST_REQUEST";
export const POPULATE_LIST = "POPULATE_LIST";
